import getServerSidePages from '@/utils/getServerSidePages/getServerSidePages'

const checkout2Enabled = () => {
  if (typeof window === 'undefined') return false
  const w = window as Window & { getCookie?: (name: string) => string }
  const ssrPages = getServerSidePages()
  const cookieflag = w.getCookie?.('_IL-ssr-checkout-page') === '1'
  return ssrPages?.length === 0 || ssrPages.includes('/checkout2') || cookieflag
}

export default checkout2Enabled
